import { useIsDisplayOptimized } from '../transitional/context/DisplayOptimizedContext';
import {
  LocaleFormat,
  getDatePlaceholder,
} from '../transitional/utils/Locale/Locale';

const DISPLAY_OPTIMIZED_PLACEHOLDER = '--';

export const useComputedPlaceholder = (placeholder?: string) => {
  const isDisplayOptimized = useIsDisplayOptimized();

  if (!placeholder && isDisplayOptimized) {
    return DISPLAY_OPTIMIZED_PLACEHOLDER;
  }

  return placeholder;
};

export const useComputedDateInputPlaceholder = (format: LocaleFormat) => {
  const isDisplayOptimized = useIsDisplayOptimized();

  if (isDisplayOptimized) {
    return DISPLAY_OPTIMIZED_PLACEHOLDER;
  }

  return getDatePlaceholder(format);
};
